import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "../../button";
import { TabPanel, Tabs } from "../../tabs";
import styled, { useTheme } from "styled-components";
import { Typo } from "../../typography";
import { isYearSelected, getNextYearByDateAndYearOffset } from "./utils";
import { MonthsWrapper } from "./single-date-picker/date-picker.styles";
const views = ["days", "months", "years"];
const centered = () => `
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const ControlsWrapper = styled.div `
  flex: 1;
  padding-top: 1rem;
  min-height: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  & > div {
    ${centered}
  }

  & > div:first-child {
    flex-grow: 1;
    justify-content: flex-start;
    padding: 0 1rem;
  }

  & > div:last-child {
    > button {
      margin-left: auto;
    }
  }

  & span {
    display: flex;
    align-items: center;

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`;
export const Wrapper = styled.div `
  flex: 1;
  padding: 0 1rem 1rem 1rem;
  min-height: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  & > div {
    ${centered}
  }

  & > div:first-child {
    flex-grow: 1;
    justify-content: flex-start;
  }

  & > div:last-child {
    > button {
      margin-left: auto;
    }
  }
`;
const StyledButton = styled((props) => _jsx(Button, Object.assign({}, props))) `
  background-color: ${({ selected, theme }) => selected ? theme.colors.grey15 : theme.colors.white};
  ${({ selected, theme }) => (selected ? `color: ${theme.colors.white}` : "")};
  &:hover {
    ${({ selected, theme }) => !selected
    ? `background-color: rgba(${theme.colors.transparentBlack}, 0.12)}`
    : ""};
  }

  &:active {
    background-color: rgb(61, 61, 61);
  }
`;
export function MonthsOrYears({ onClose, onSelectMonth, onSelectYear, onSelectStateMonth, selectedMonth, monthNames, }) {
    const theme = useTheme();
    const [selectedDate, setSelectedMonth] = useState(selectedMonth);
    const [selectedTab, setSelectedTab] = useState(0);
    return (_jsxs(MonthsWrapper, { children: [_jsx(Tabs, Object.assign({ tabPanelPosition: "bottom", items: views.slice(1, 3).map((_, i) => ({
                    title: i === 0
                        ? monthNames[selectedDate.getMonth()]
                        : String(selectedDate.getFullYear()),
                })), alignment: "horizontal", onTabChange: (t) => setSelectedTab(t.index) }, { children: _jsxs(TabPanel, { children: [_jsx("div", Object.assign({ className: "months" }, { children: new Array(12).fill(null).map((_, monthIndex) => {
                                return (_jsx(StyledButton, Object.assign({ selected: monthIndex === selectedDate.getMonth(), onClick: () => {
                                        const date = new Date(selectedDate);
                                        date.setMonth(monthIndex);
                                        setSelectedMonth(date);
                                    }, stylingType: "icon" }, { children: _jsx(Typo, Object.assign({ fontWeight: theme.fontWeights.regular, variant: "p2" }, { children: monthNames[monthIndex].slice(0, 3) })) }), `months-${String(monthIndex)}`));
                            }) })), _jsx("div", Object.assign({ className: "years" }, { children: new Array(16).fill(null).map((_, year) => {
                                return (_jsx(StyledButton, Object.assign({ selected: isYearSelected(selectedDate, year - (selectedDate.getFullYear() % 16)), onClick: () => {
                                        const date = new Date(selectedDate);
                                        date.setFullYear(Number(getNextYearByDateAndYearOffset(selectedDate, year - (selectedDate.getFullYear() % 16))));
                                        setSelectedMonth(date);
                                    }, stylingType: "icon" }, { children: _jsx(Typo, Object.assign({ fontWeight: theme.fontWeights.regular, variant: "p2" }, { children: getNextYearByDateAndYearOffset(selectedDate, year - (selectedDate.getFullYear() % 16)) })) }), `year-${String(year)}`));
                            }) }))] }) })), _jsxs(Wrapper, { children: [selectedTab === 1 && (_jsxs("div", { children: [_jsx(Button, { onClick: () => {
                                    const currentSelected = new Date(selectedDate);
                                    currentSelected.setFullYear(currentSelected.getFullYear() - 16);
                                    setSelectedMonth(currentSelected);
                                }, stylingType: "icon", isIcon: true, symbol: "ChevronLeft" }), _jsx(Button, { onClick: () => {
                                    const currentSelected = new Date(selectedDate);
                                    currentSelected.setFullYear(currentSelected.getFullYear() + 16);
                                    setSelectedMonth(currentSelected);
                                }, stylingType: "icon", isIcon: true, symbol: "ChevronRight" })] })), _jsx("div", { children: _jsx(Button, Object.assign({ onClick: () => {
                                if (typeof onSelectMonth === "function")
                                    onSelectMonth(selectedDate);
                                if (typeof onSelectYear === "function")
                                    onSelectYear(selectedDate);
                                if (typeof onSelectStateMonth === "function")
                                    onSelectStateMonth();
                                onClose();
                            }, stylingType: "flatHighlight" }, { children: "OK" })) })] })] }));
}
